import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import contentMan from "../../../img/contentMan.svg";
import contentfolder from "../../../contentImgs/folder.png";

import LoadingButton from "../../../Loading/LoadingButton";
import Snackbar from "../../../../Snackbar";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,Timer,AudioLines,
  FolderHeart, Forward,Earth,ListChecks,Gift,Settings,BetweenHorizontalStart,
  ImagePlay,Film,AlarmSmoke,BellElectric,CircleCheck,LayoutGrid ,CornerDownRight,BotMessageSquare,ChevronUp,ChevronDown,
  GripHorizontal,
  CopyPlus,
  Bookmark,
  Pencil,
  Trash2,
  Recycle} from 'lucide-react';
import CreateFolderPopup from "../ContentPopUp/CreateFolderPopup";
import FolderFilterCard from "../FolderFilterCard";
import AddToFolderButton from "../AddToFolderButton";
import { createNewFolder, getAllFoldersByApp, reArrangeFolders } from "../../../../store/actions/CreateContent/FolderAPI/FolderAPIs";
import FolderFilterCardTwo from "../FolderFilterCardTwo";
import FolderFilterCardThree from "../FolderFilterCardTwoThree";


const FolderForQuiz =({setCreateNewFolderStatus,setFolderRadioItemBack ,closeFolderForQuiz})=>{

     const dispatch = useDispatch();
        const [openAppDesignPopUp,setopenAppDesignPopUp]  = useState(false);
              const [openAppDesignPopUpInnerContent,setopenAppDesignPopUpInnerContent]  = useState("appThemes");
           const user = useSelector((state)=>state?.user?.user);
           const [FolderInputData ,setFolderInputData] =useState("")
           const [activeFilterOne, setActiveFilterOne] =useState(true);
           const [activeFilterTwo, setActiveFilterTwo] =useState(false);
           const [activeFilterThree, setActiveFilterThree] =useState(false);
           const [activeFilterFour, setActiveFilterFour] =useState(false);
           const [activeFilterASC, setActiveFilterASC] =useState(true);
           const [activeFilterDESC, setActiveFilterDESC] =useState(false);
               const [snackbarVisible, setSnackbarVisible] = useState(false);
                     const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                     const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                   
                              const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
                   const showSnackbar = () => {
                     setSnackbarVisible(true);
                   };
                  
                   const hideSnackbar = () => {
                     setSnackbarVisible(false);
                   };
             
             
                        
                        
                     
                    const [animate, setAnimate] = useState(false);
      
       const [loader , setLoader] =useState({status:true});
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }


      
       const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
     const appId = useSelector((state)=>state?.app?.app?.ID);
          
           const [visibility,setVisibility] =useState("public");
           const [orderBy,setOrderBy] =useState("ASC");
           const [itemArr, setItemArr] = useState([]);
           const [itemReorderArr, setItemReorderArr] = useState([]);
           const [itemId, setItemId] = useState("");
           const [deleteFolderPopUp, setDeleteFolderPopUp] = useState(false);
           const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{}]);
           const [openContentInFolder, setOpenContentInFolder] = useState("");
           const [folderRadioItem, setFolderRadioItem] = useState({});
           
 const [folderItem ,setFolderItem] =useState({});
 const updateItemTitle = (ID, newTitle) => {
  const updatedItems = itemArr.map(item =>
    item?.ID === ID ? { ...item, Name :newTitle } : item
  
  ); 

 // console.log(updatedItems)
  setItemArr(updatedItems);
};
const sendBackFolder = (folder) => {
  const updatedItems = [...itemArr, folder]
  const updatedItemsMenuorder = [...itemReorderArr, {ID:folder?.ID,menuOrder:folder?.menuOrder}]
  setItemReorderArr( updatedItemsMenuorder);
 // console.log(updatedItems)
  setItemArr(updatedItems);
};

      useEffect((e)=>{
        if(setCreateNewFolderStatus=="openPopUp"){
          
    setActiveFilterOne(true);setActiveFilterTwo(true);;setActiveFilterThree(false);setVisibility('public'); 
    setFolderItem(null);    setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createFolder");
        }
    fireGetAllCoursesByApp()
       
        },[visibility,orderBy,postIdCourse]);
        const fireGetAllCoursesByApp=()=>{
          setItemArr([])
                
        
                
          if(visibility=='public'){setActiveFilterTwo(true)}
          // if(openAppDesignPopUp){setActiveFilterTwo(true);setVisibility('public');}
          
        
          setItemArrLoading([{},{},{},{}])
        // Popup When Course is not selected
          if(courseData){}else{}
        
        setLoader({status:true});
            // console.log({
              //   token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",appToken:AppToken,
              //   });
              const apiData = dispatch(getAllFoldersByApp({
                token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                appToken:AppToken,visibility:visibility,orderBy:orderBy,appId:appId
                }));
              /* get response as Promise   */
              apiData.then(response => {
                // console.log(response)
        
                if(response){
                 
                  if(response){
                setResponseMessage(response?.message);
                setSnackbarColor("rgba(144, 202, 249,1)");
              
                if(response?.folders)  {setItemArr(response?.folders); 
        
                  const reorderArray = response?.folders.map(item => ({
                    ID: item.ID,
                    menuOrder: item.menuOrder
                }));
                setItemReorderArr(reorderArray);
                //  console.log(reorderArray)
                
                }else{setItemArr([]);};
                setItemArrLoading([]);
            setLoader({status:false});
            
            // setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
            },1000)
               }else{
            //     setResponseMessage("Something Went Wrong...");
                  
            //     setSnackbarColor("#958FDA");
            //   //   
                
                 
            // setLoader({status:false});
            // setItemArrLoading([{},{},{},{}]);
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
               }
                  
                // dispatch({
                //   type: "UPDATE_APP_TOKEN",
                  
                //   payload:response?.course?.AppToken
                // });  
              //  console.log(response?.course);
             
               // 
               if(response?.logout){
                // pop up response?.logoutInfo
                //console.log(response?.logoutInfo)
            
                setResponseMessage("You are Logged Out!!!");
                  
                setSnackbarColor("#958FDA");
              
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                setTimeout(()=>{
                  dispatch({type:"LOGOUT"});
            
                },3000)
                
              }
            /* resetting Login input Fields */
            
                }else{
                  setResponseMessage("Something Went Wrong...");
                  
                  setSnackbarColor("#958FDA");
                
                 setItemArrLoading([{},{},{},{}]);
                   
              setLoader({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)    }
            
              }).catch(error => {
             
                //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("#958FDA");
           
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                console.error(error);
              });
         }

const handleReArrangeFolder =(reorderedItemsArray)=>{
// console.log({
//   token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
//   appToken:AppToken,menuOrder:itemReorderArr,orderBy:orderBy
//   })


  const apiData = dispatch(reArrangeFolders({
    token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
    appToken:AppToken,menuOrder:JSON.stringify(reorderedItemsArray),orderBy:orderBy
    }));
  /* get response as Promise   */
  apiData.then(response => {
    // console.log(response)

 
     
      if(response){
        
  // setSnackbarVisible(true);
    setResponseMessage("Saved Successfully!!!");
    setSnackbarColor("rgba(144, 202, 249,1)");
  
   
setLoader({status:false});

setTimeout(()=>{
  
  setSnackbarVisible(false);
},1000)
   }else{

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
   }
      
    
   if(response?.logout){
    // pop up response?.logoutInfo
    //console.log(response?.logoutInfo)

    setResponseMessage("You are Logged Out!!!");
      
    setSnackbarColor("#958FDA");
 
    
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    setTimeout(()=>{
      dispatch({type:"LOGOUT"});

    },3000)
    
  }


   

  }).catch(error => {
 
    //popup of error Info
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
    
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    console.error(error);
  });
}



const handleDeleteFolder=(val,folderID)=>{
  let editType=val;

  setLoader({status:true});

        const apiData = dispatch(createNewFolder({
      token:token,courseId:postIdCourse ,postParent:postIdCourse ,userEmail:user_email?user_email:null,
      currentToken:currentToken?currentToken:null,appToken:AppToken,
      editType:editType,postId:folderID,menuOrder:1}));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){

        // console.log(response)
        if(response?.folder){
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
   if(val=="deleteFolder"){
    // setActiveFilterTwo(false);;setActiveFilterThree(true);
    const removedItems = itemArr.filter(item => item?.ID !== response?.folder?.ID);
    setItemArr(removedItems);
   } 
    if(val=="restoreFolder"){
      // setActiveFilterTwo(true);;setActiveFilterThree(false);
      const removedItems = itemArr.filter(item => item?.ID !== response?.folder?.ID);
    setItemArr(removedItems);
    }

  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }

        const flattenedData = itemArr!=[]?Object.values(itemArr):'';

        const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';


        const [reorderFolderPopUp, setReorderFolderPopUp] =useState(false);
        const [bookmarkListPopUp, setBookmarkListPopUp] =useState(false);
        
const [draggedIndex, setDraggedIndex] = useState('');
const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone
const [selectedItemIndex, setSelectedItemIndex] = useState(null); // Track hovered drop zone

const handleDragStart = (e, index) => {
  
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData("dragIndex", index);
  
};

const handleDrop = (e, dropIndex) => {
  const dragIndex = e.dataTransfer.getData("dragIndex");
  if (dragIndex === dropIndex) return;

  const updatedItems = [...itemArr];
  const [draggedItem] = updatedItems.splice(dragIndex, 1);
  updatedItems.splice(dropIndex, 0, draggedItem);

  const reorderedItems = updatedItems.map((item, index) => ({
    ...item,
    ID: item.ID,
    menuOrder:index+1
  }));
  const updatedItemsReorder = [...itemReorderArr];
  const [draggedItemReorder] = updatedItemsReorder.splice(dragIndex, 1);
  updatedItemsReorder.splice(dropIndex, 0, draggedItemReorder);


  setItemArr(reorderedItems);

  const reorderedItemsReorder = updatedItemsReorder.map((item, index) => ({
    ...item,
    ID: item.ID,
    menuOrder:index+1
  }));


// console.log(reorderedItemsReorder)
  setItemReorderArr(reorderedItemsReorder);
  
  setTimeout(()=>{handleReArrangeFolder(reorderedItemsReorder);},1000)
  // setTimeout(()=>{setReorderFolderPopUp(true);},1000)
  // pop up For Saving This Order . Send Array Json To Backend
  // console.log(itemReorderArr)
  setDraggedIndex('');
  setHoveredDropZone(null); // Reset hovered drop zone
};

const handleDragOver = (e, index) => {
  e.preventDefault();
   // Set the hovered drop zone
};

const handleDragEnd = () => {
  setDraggedIndex('');
  setHoveredDropZone(null); // Clear hovered drop zone
};
   

    return (<><div>   
   <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:99999,cursor:"pointer"}} onClick={()=>closeFolderForQuiz(false)}  className="appDesignPopUpOpacity"> </div>
        <div   className="AreYouSurePopUpTwo" style={{borderRadius: '20px',top:"50px",}}> 
        <h2 align="center">
  
  Choose Folder For Your Quiz
  
  </h2>
<div className="bookmarkListScroll" style={{overflowY:"auto",height:"80%",overflowX:"hidden"}}>

      
          
                
    {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
        <div   className="" style={{borderRadius:"25px",margin:"0px",padding:"0px",left:"0%",right:"0%",}}> 
        <div className="" style={{borderRadius:"25px",margin:"0px",}} >
<div className="themeNone"  style={{margin:"0px",marginTop:"5px",
  minHeight:"190px",border:"0px dashed rgba(144, 202, 249,1)",position:"relative"}}>
{/* <div style={{position:"absolute",right:"15px",top:"0px",borderTopLeftRadius:"5px",
  borderBottomLeftRadius:"50px",background:"#EBF6FF"}}>
<img     src={contentMan} 
        alt="selected Img"
   style={{cursor:"pointer",width:"100px"
    
   }}/>
</div> */}
<div className=" " > 


{flattenedData?flattenedData?.map((item, index) => 
        (<div  index={index} key={item?.ID} 
          >
            <div
             style={{
              width:"100%"
             
              
            }}  
          
            
            >
    <label className={"radio-outer"}  style={{borderRadius:"5px", padding:"5px",paddingLeft:"15px",paddingTop:"0px",margin:"0px",position:"relative"}}>
<div  className="courseContentItemOuterHeadActiveSettings" style={{marginTop:"0px",paddingLeft:"10px",border:"2px solid #f1f1f1" ,background:"#ffffff"}}>
<div className="courseContentItemJustifyContentIcons"  style={{borderRadius:"5px", padding:"5px",paddingLeft:"15px",paddingTop:"8px",marginTop:"2px",position:"relative"}}> 
                                         
<input type={"radio"} 
            className="input-textbox"    value={item} name={"quizFolderRadio"}  
onChange={e=>{
    setFolderRadioItemBack(item)


}

}
/>
              <span class={"circle"}></span>                       
             
<img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"25px",height:"25px",paddingLeft:"15px",marginTop:"-7px"
    
   }}/> </div><div className="courseContentItemJustifyContent"> <div className="themeNone "
 style={{fontSize:"15px",marginLeft:"15px",color:"#111",fontWeight:"700"}}> 
  {item?.Name}
 
      </div></div><div  className="courseContentItemOuterHeadActiveSettingsInn"
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
  <div></div><div></div><div></div><div></div>
 </div>
 <div></div></div> </label>  </div>  
  
  </div>)):""}
      {flattenedDataLoading?.map((item, index) => 
        (<div  index={index} key={index} 
          >
<div  className="chapterContentItemGridOuter" style={{margin:"10px",minHeight:"40px",marginTop:"10px",paddingLeft:"10px",background:"#ffffff"}}>
         <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
   </div><div  className="text-linetw" style={{marginTop:"5px",height:"17px",width:"94%",paddingLeft:"10px",padding:"5px"}}>
</div><div  className="courseContentItemOuterHeadActiveSettingsInn"
   style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
     <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div>  <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div><div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div></div>
     </div>  </div>)) }

  {flattenedDataLoading?.length==0?flattenedData?.length?"": <div align="center"style={{margin:"15px",padding:"10px",borderRadius:"15px",background:"rgba(255,114,94,0.1)"}}><h3 style={{"textAlign":"center",
       
      }}> Opps... <span className="coloredTextV1">No Folders Found !!!</span> {activeFilterThree?" Deleted Folders Will Show Up Here..."
        :" Create Your First Folder And Add Contents , Quizzes or Homeworks." } </h3>
      <h5>
         </h5>
      </div>:""}
      


</div>
<div className="contentsRemainingButtonOuter" >
  <div  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{
           
    setActiveFilterOne(true);setActiveFilterTwo(true);;setActiveFilterThree(false);setVisibility('public'); 
    setFolderItem(null);    setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createFolder");
            }}  className="themeNone contentsRemainingButtonOuter"  style={{fontSize:"16px",color:"#fff",
  border:"1px solid #958FDA",fontWeight:"700",cursor:"pointer",
 borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px",background:"#958FDA"}}>
  <Plus  strokeWidth={3}   absoluteStrokeWidth  size={25}  color="#fff"/> <div className="themeNone"  style={{margin:"0px"}}> 
    <div  className="themeNone" style={{marginTop:"-5px"}}>  Add New Folder</div></div></div>
  </div>
  </div>  
            

  </div>
        
          
</div>



 {openAppDesignPopUp?<div className="appDesignPopUp"  style={{zIndex:99999,top:"50px",} }>
   <div   onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} style={{cursor:"pointer",}} onClick={()=>{setopenAppDesignPopUp()}} 
            className="appDesignPopUpOpacity"></div>
   <div   className="appDesignPopUpInner " style={{margin:'0px',top:"50px",
    overflowY: "auto",zIndex:9999999,background:"#f9f9f9"}}>
         
        <div className="userInfoLiner" style={{background:"#ffffff"}} >
        <div className="userInfoLinerInn" style={{background:"#ffffff"}}>
        
          <img  className="userInfoLinerPic"src={user?.profile_pic?user?.profile_pic:"https://img.freepik.com/free-vector/illustration-businessman_53876-5856.jpg"} alt={user?.profile_pic} />
           <div className="userInfoLinerName">
        
        
           {openAppDesignPopUpInnerContent=="createFolder"? <h2>Create  A Folder</h2> :
          ""}
          </div>
          </div>  <div className="userInfoLinerInn">
          {/* <div   onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} style={{cursor:"pointer",}} onClick={()=>{setopenAppDesignPopUp()}}   className="userInfoLinerButton">
        Close
          </div> */}
          </div>
          </div>
          
        

       <div style={{height:"85vh",overflow:"auto",}}>
       
       {openAppDesignPopUpInnerContent=="createFolder"?
         <CreateFolderPopup menuOrder={flattenedData?.length} sendBackFolder={(folder)=>{sendBackFolder(folder)}} changeItemTitle={(id,title)=>{updateItemTitle(id,title)} }  folderItem={folderItem} setopenAppDesignPopUp={setopenAppDesignPopUp} /> 
         :openAppDesignPopUpInnerContent=="createContent"?
         <div className="gridForWhatsNextAfterYT2" style={{alignContent:"center",textAlign:"center",marginTop:"50px",
     
      transition: 'transform 2s ease, opacity 1s ease',
    }}>
      
         
      </div>  :"" }
      
      </div>
        
         </div></div>:""}
         </div>
         
         <div align="center" className="" style={{position:"absolute",left:"0px",right:"00px",bottom:"10px",padding:"10px",display:"flex",justifyContent:"center",alignContent:"center",textAlign:"center",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><div className="" >
 <div  onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave} onClick={()=>{
          
   setActiveFilterOne(true);setActiveFilterTwo(true);;setActiveFilterThree(false);setVisibility('public'); 
   setFolderItem(null);    setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createFolder");
           }}  className="themeNone contentsRemainingButtonOuter"  style={{fontSize:"16px",color:"#fff",
 border:"1px solid #958FDA",fontWeight:"700",cursor:"pointer",
borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px",background:"#958FDA"}}>
 <Plus  strokeWidth={3}   absoluteStrokeWidth  size={25}  color="#fff"/> <div className="themeNone"  style={{margin:"0px"}}> 
   <div  className="themeNone" style={{marginTop:"-5px"}}>  Add New Folder</div></div></div>
 </div>
</div>
         
         </div></div>
          </>)
}
export default FolderForQuiz;

